import React, { useEffect, useState } from 'react';
import { Timeline, TimelineItem } from 'vertical-timeline-component-for-react';
import Select from 'react-select';
import { format } from '~/Utils/Helpers';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import './timeline.css';
import { FaFilter, FaFile, FaDownload, FaEye } from 'react-icons/fa';
import { Button, Modal } from 'react-bootstrap';
import {
  Note,
  Pencil,
  NotePencil,
  Envelope,
  DeviceMobile,
  CalendarCheck,
  Scroll,
  WhatsappLogo,
  PhoneCall,
} from 'phosphor-react';
import { FaWindowClose } from 'react-icons/fa';
import { TIPO_ATIVIDADE, USUARIO_AUTO, caracteristicas } from '~/constant';
import {
  downloadAnexoAnotacao,
  visualizarAnexoAnotacao,
} from '~/Services/Service';
import AuthStorage from '~/Utils/AuthStorage';

const AtividadesTimeline = ({ vinculoSelecionado, editarAtividade }) => {
  const [atividadesFiltradas, setAtividadesFiltradas] = useState(null);
  const [filtroAtividade, setFiltroAtividade] = useState(999);
  const [mostrarModalHistorico, setMostrarModalHistorico] = useState(false);
  const [historicoSelecionado, setHistoricoSelecionado] = useState(null);

  const toggleModalHistorico = () => {
    setMostrarModalHistorico(!mostrarModalHistorico);
  };

  useEffect(() => {
    if (vinculoSelecionado && vinculoSelecionado.atividades) {
      if (filtroAtividade) {
        setAtividadesFiltradas(
          vinculoSelecionado.atividades.filter(atividade => {
            if (filtroAtividade === TIPO_ATIVIDADE.TODOS) return true;
            return atividade.tipo_atividade === filtroAtividade;
          })
        );
      }
    }
  }, [filtroAtividade, vinculoSelecionado && vinculoSelecionado.atividades]);

  function getTipoAtividadeTexto(tipo) {
    switch (tipo) {
      case TIPO_ATIVIDADE.ANOTACAO:
        return 'uma anotação';
      case TIPO_ATIVIDADE.EMAIL:
        return 'um E-mail';
      case TIPO_ATIVIDADE.SMS:
        return 'um SMS';
      case TIPO_ATIVIDADE.WHATSAPP:
        return 'uma mensagem';
      case TIPO_ATIVIDADE.LIGACAO:
        return 'uma ligação';
      default:
        return 'uma atividade';
    }
  }

  return (
    <div>
      <div className="filter-activities mb-3">
        <FaFilter className="filter-icon mr-2" size={14} />
        <label className="label-acoes">Filtrar atividades por</label>
        <Select
          options={[
            { value: 999, label: 'Todos' },
            { value: 1, label: 'Anotação' },
            { value: 2, label: 'E-mail' },
            { value: 3, label: 'Tarefa' },
            { value: 4, label: 'SMS' },
            { value: 5, label: 'Visita' },
            { value: 6, label: 'WhatsApp' },
            { value: 7, label: 'Ligação' },
          ]}
          styles={customStyles}
          components={{ DropdownIndicator }}
          placeholder="Selecione uma opção"
          isSearchable={false}
          defaultValue={[{ value: filtroAtividade, label: 'Todos' }]}
          onChange={selectedOption => {
            setFiltroAtividade(selectedOption.value);
          }}
        />
      </div>

      {atividadesFiltradas && (
        <div>
          <Timeline lineColor={'#ddd'} animate={true}>
            {atividadesFiltradas.map((atividade, index) => (
              <TimelineItem
                key={index}
                dateText={format.date(
                  atividade.data_criacao,
                  'DD/MM/YYYY HH:mm'
                )}
                dateInnerStyle={{
                  background: '#58d0ff',
                }}
                style={{
                  color: '#58d0ff',
                }}
              >
                <div className="timeline-item-content">
                  <h5 className="font-weight-bold d-flex justify-content-between">
                    <div>
                      {atividade.descricao_tipo_atividade}
                      {(() => {
                        switch (atividade.tipo_atividade) {
                          case TIPO_ATIVIDADE.ANOTACAO:
                            return <NotePencil size={28} className="ml-2" />;
                          case TIPO_ATIVIDADE.EMAIL:
                            return <Envelope size={28} className="ml-2" />;
                          case TIPO_ATIVIDADE.TAREFA:
                            return <Note size={28} className="ml-2" />;
                          case TIPO_ATIVIDADE.SMS:
                            return <DeviceMobile size={28} className="ml-2" />;
                          case TIPO_ATIVIDADE.VISITA:
                            return <CalendarCheck size={28} className="ml-2" />;
                          case TIPO_ATIVIDADE.WHATSAPP:
                            return <WhatsappLogo size={28} className="ml-2" />;
                          case TIPO_ATIVIDADE.LIGACAO:
                            return <PhoneCall size={28} className="ml-2" />;
                        }
                      })()}
                    </div>
                    <strong
                      title="Código da Atividade"
                      style={{ fontSize: '15px' }}
                    >
                      {atividade.codigo_atividade}
                    </strong>
                  </h5>
                  <div className="json-details">
                    <div className="json-item">
                      <strong>Usuário:</strong> {atividade.nome_usuario}
                    </div>
                    {atividade.atividade &&
                      (() => {
                        const objetoAtividade = JSON.parse(atividade.atividade);
                        switch (atividade.tipo_atividade) {
                          case TIPO_ATIVIDADE.TAREFA:
                            return (
                              <>
                                {atividade.atividade_vinculada &&
                                  atividade.atividade_vinculada
                                    .codigo_atividade > 0 && (
                                    <>
                                      <div className="json-item">
                                        <strong>Atividade Vinculada:</strong>{' '}
                                        Possui
                                        {' ' +
                                          getTipoAtividadeTexto(
                                            atividade.atividade_vinculada
                                              .tipo_atividade
                                          )}
                                      </div>
                                    </>
                                  )}

                                <div className="json-item">
                                  <strong>Descrição:</strong>{' '}
                                  {objetoAtividade.descricao || 'Não informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Data para conclusão:</strong>{' '}
                                  {format.date(objetoAtividade.data) ||
                                    'Não informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Prioridade:</strong>{' '}
                                  {objetoAtividade.prioridade ||
                                    'Não informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Situação:</strong>{' '}
                                  {objetoAtividade.situacao || 'Não informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Tipo de Responsável:</strong>{' '}
                                  {objetoAtividade.tipoResponsavel ||
                                    'Não informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Responsável:</strong>{' '}
                                  {objetoAtividade.responsavel ||
                                    'Não informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Lembrete por E-mail:</strong>{' '}
                                  {objetoAtividade.lembreteEmail ||
                                    'Não informado'}
                                </div>
                              </>
                            );
                          case TIPO_ATIVIDADE.ANOTACAO:
                            const nomeArquivoAnexo = atividade.caminho_arquivo
                              ? atividade.caminho_arquivo
                                  .split('/')
                                  .pop()
                                  .split('\\')
                                  .pop()
                              : '';
                            const handleDownloadAnexo = async () => {
                              try {
                                await downloadAnexoAnotacao(
                                  atividade.codigo_atividade,
                                  nomeArquivoAnexo
                                );
                              } catch (error) {
                                console.error('Erro ao baixar anexo:', error);
                              }
                            };
                            const handleVisualizarAnexo = async () => {
                              try {
                                await visualizarAnexoAnotacao(
                                  atividade.codigo_atividade,
                                  nomeArquivoAnexo
                                );
                              } catch (error) {
                                console.error(
                                  'Erro ao visualizar anexo:',
                                  error
                                );
                              }
                            };
                            return (
                              <>
                                <div className="json-item">
                                  <strong>Descrição:</strong>
                                  <pre className="text-area-content bordered">
                                    {objetoAtividade.descricao}
                                  </pre>
                                </div>
                                {atividade.historico &&
                                  atividade.historico.length > 0 &&
                                  (() => {
                                    const ultimaEdicao = atividade.historico[0];
                                    const descAnterior = JSON.parse(
                                      ultimaEdicao.descricao_antiga || '{}'
                                    );
                                    return (
                                      <div
                                        className="json-item mt-1"
                                        style={{
                                          fontSize: '0.85em',
                                          color: '#666',
                                        }}
                                      >
                                        <em>
                                          Editado por:{' '}
                                          {ultimaEdicao.usuario_alteracao} (
                                          {format.date(
                                            ultimaEdicao.data_atualizacao,
                                            'DD/MM/YYYY - HH[h]mm'
                                          )}
                                          )
                                        </em>
                                        {descAnterior.descricao && (
                                          <details className="mt-1">
                                            <summary
                                              style={{
                                                cursor: 'pointer',
                                                color: '#888',
                                              }}
                                            >
                                              Ver descrição anterior
                                            </summary>
                                            <pre
                                              className="text-area-content bordered mt-1"
                                              style={{
                                                background: '#f8d7da',
                                                color: '#721c24',
                                              }}
                                            >
                                              {descAnterior.descricao}
                                            </pre>
                                          </details>
                                        )}
                                      </div>
                                    );
                                  })()}
                                {atividade.caminho_arquivo && (
                                  <div className="json-item mt-2">
                                    <strong>Anexo:</strong>
                                    <div className="d-flex align-items-center bg-light rounded p-2 mt-1">
                                      <FaFile className="text-secondary mr-2" />
                                      <span className="flex-grow-1 text-truncate">
                                        {nomeArquivoAnexo}
                                      </span>
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        className="ml-2"
                                        title="Visualizar anexo"
                                        onClick={handleVisualizarAnexo}
                                      >
                                        <FaEye />
                                      </Button>
                                      <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        className="ml-1"
                                        title="Baixar anexo"
                                        onClick={handleDownloadAnexo}
                                      >
                                        <FaDownload />
                                      </Button>
                                    </div>
                                  </div>
                                )}
                              </>
                            );
                          case TIPO_ATIVIDADE.EMAIL:
                            return (
                              <>
                                <div className="json-item">
                                  <strong>Enviado para:</strong>{' '}
                                  {objetoAtividade.destinatario}
                                </div>
                                <div className="json-item">
                                  <strong>Email enviado:</strong>
                                  <div
                                    className="email-content"
                                    dangerouslySetInnerHTML={{
                                      __html: objetoAtividade.descricao,
                                    }}
                                  ></div>
                                </div>
                              </>
                            );
                          case TIPO_ATIVIDADE.SMS:
                            return (
                              <div className="json-item">
                                <strong>Mensagem enviada:</strong>
                                <pre className="text-area-content bordered">
                                  {objetoAtividade.descricao}
                                </pre>
                                <div className="json-item">
                                  <strong>Enviado para:</strong>{' '}
                                  {format.celular(objetoAtividade.telefone)}
                                </div>
                              </div>
                            );
                          case TIPO_ATIVIDADE.VISITA:
                            return (
                              <>
                                <div className="json-item">
                                  <strong>Descrição:</strong>{' '}
                                  {objetoAtividade.descricao || 'Não Informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Data para conclusão:</strong>{' '}
                                  {format.date(objetoAtividade.data) ||
                                    'Não Informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Situação:</strong>{' '}
                                  {objetoAtividade.situacao || 'Não Informado'}
                                </div>
                                <div className="json-item">
                                  <strong>PDV:</strong>{' '}
                                  {objetoAtividade.pdv || 'Não Informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Tipo de Responsável:</strong>{' '}
                                  {objetoAtividade.tipoResponsavel ||
                                    'Não Informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Responsável:</strong>{' '}
                                  {objetoAtividade.responsavel ||
                                    'Não Informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Visita Virtual:</strong>{' '}
                                  {objetoAtividade.visitaVirtual ||
                                    'Não Informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Tipo de Visita:</strong>{' '}
                                  {objetoAtividade.tipoVisita ||
                                    'Não Informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Recalcular Vencimento:</strong>{' '}
                                  {objetoAtividade.recalcularVencimento ||
                                    'Não Informado'}
                                </div>
                                {objetoAtividade.formasNotificacoes && (
                                  <div className="json-item">
                                    <strong>Formas de Notificação:</strong>{' '}
                                    {objetoAtividade.formasNotificacoes}
                                  </div>
                                )}
                              </>
                            );
                          case TIPO_ATIVIDADE.WHATSAPP:
                            return (
                              <div className="json-item">
                                <strong>Descrição:</strong>
                                <pre className="text-area-content bordered">
                                  {objetoAtividade.descricao}
                                </pre>
                              </div>
                            );
                          case TIPO_ATIVIDADE.LIGACAO:
                            return (
                              <>
                                <div className="json-item">
                                  <strong>Data ligação:</strong>{' '}
                                  {format.datetime(objetoAtividade.data) ||
                                    'Não informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Telefone:</strong>{' '}
                                  {format.celular(objetoAtividade.telefone) ||
                                    'Não informado'}
                                </div>
                                <div className="json-item">
                                  <strong>Descrição:</strong>
                                  <pre className="text-area-content bordered">
                                    {objetoAtividade.descricao}
                                  </pre>
                                </div>
                              </>
                            );
                        }
                      })()}
                  </div>
                  {(atividade.tipo_atividade === TIPO_ATIVIDADE.TAREFA ||
                    atividade.tipo_atividade === TIPO_ATIVIDADE.VISITA ||
                    atividade.tipo_atividade === TIPO_ATIVIDADE.ANOTACAO) && (
                    <div className="d-flex justify-content-end">
                      {(() => {
                        const usuarioLogado = AuthStorage.getUser().usuario;
                        const ehCriador =
                          atividade.codigo_usuario === usuarioLogado;
                        const ehCavMaster = AuthStorage.temCaracteristica(
                          caracteristicas.CavMaster
                        );
                        const podeEditar =
                          atividade.tipo_atividade === TIPO_ATIVIDADE.ANOTACAO
                            ? ehCriador || ehCavMaster
                            : atividade.codigo_usuario !== USUARIO_AUTO;
                        return podeEditar ? (
                          <Button
                            className={`btn-timeline${
                              atividade.historico &&
                              atividade.historico.length > 0
                                ? ' mr-4'
                                : ''
                            }`}
                            onClick={() => {
                              editarAtividade(
                                atividade,
                                atividade.tipo_atividade
                              );
                            }}
                            title={'Editar atividade'}
                          >
                            {' '}
                            <Pencil size={18} />
                          </Button>
                        ) : null;
                      })()}
                      {atividade.historico && atividade.historico.length > 0 && (
                        <Button
                          className="btn-timeline"
                          onClick={() => {
                            toggleModalHistorico();
                            setHistoricoSelecionado(atividade.historico);
                          }}
                          title="Ver histórico da atividade"
                        >
                          {' '}
                          <Scroll size={18} />
                        </Button>
                      )}
                    </div>
                  )}
                </div>
              </TimelineItem>
            ))}
            {atividadesFiltradas.length === 0 && (
              <TimelineItem
                key={'nenhuma-atividade'}
                dateText={format.date(new Date(), 'DD/MM/YYYY HH:mm')}
                dateInnerStyle={{
                  background: '#757575',
                }}
                style={{
                  color: '#757575',
                }}
              >
                <h5 className="font-weight-bold">
                  Nenhuma atividade encontrada.
                </h5>
              </TimelineItem>
            )}
          </Timeline>
        </div>
      )}

      {mostrarModalHistorico && (
        <Modal
          size="xl"
          show={mostrarModalHistorico}
          backdrop="static"
          onHide={() => {
            toggleModalHistorico();
            setHistoricoSelecionado(null);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Histórico atividade</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Timeline lineColor={'#ddd'} animate={true}>
                {historicoSelecionado.map((historico, index) => (
                  <TimelineItem
                    key={index}
                    dateText={format.date(
                      historico.data_atualizacao,
                      'DD/MM/YYYY HH:mm'
                    )}
                    dateInnerStyle={{
                      background: '#58d0ff',
                    }}
                    style={{
                      color: '#58d0ff',
                    }}
                  >
                    <div className="timeline-item-content">
                      <h5 className="font-weight-bold d-flex justify-content-between">
                        <div>
                          Atividade modificada -{' '}
                          {historicoSelecionado.length - index}
                          {(() => {
                            switch (historico.tipo_atividade) {
                              case TIPO_ATIVIDADE.ANOTACAO:
                                return (
                                  <NotePencil size={28} className="ml-2" />
                                );
                              case TIPO_ATIVIDADE.EMAIL:
                                return <Envelope size={28} className="ml-2" />;
                              case TIPO_ATIVIDADE.TAREFA:
                                return <Note size={28} className="ml-2" />;
                              case TIPO_ATIVIDADE.SMS:
                                return (
                                  <DeviceMobile size={28} className="ml-2" />
                                );
                              case TIPO_ATIVIDADE.VISITA:
                                return (
                                  <CalendarCheck size={28} className="ml-2" />
                                );

                              case TIPO_ATIVIDADE.WHATSAPP:
                                return (
                                  <WhatsappLogo size={28} className="ml-2" />
                                );
                            }
                          })()}
                        </div>
                      </h5>
                      <div className="mt-2">
                        <strong>Atualizado por : </strong>
                        {historico.usuario_alteracao}
                      </div>
                      <div className="mt-2">
                        <strong>Dados Atualizados: </strong>
                        <div className="json-details">
                          {historico &&
                            (() => {
                              const nova = JSON.parse(
                                historico.descricao_nova || '{}'
                              );
                              const antiga = JSON.parse(
                                historico.descricao_antiga || '{}'
                              );

                              const coresSuaves = {
                                red: '#f8d7da',
                                green: '#d4edda',
                              };
                              const textColors = {
                                red: '#721c24',
                                green: '#155724',
                              };

                              const gerarPill = (valor, cor) => (
                                <span
                                  style={{
                                    backgroundColor: coresSuaves[cor],
                                    color: textColors[cor],
                                    padding: '2px 6px',
                                    borderRadius: '10px',
                                    margin: '0 4px',
                                    display: 'inline-block',
                                  }}
                                >
                                  {valor}
                                </span>
                              );

                              const isData = campo =>
                                campo.toLowerCase().includes('data');

                              const renderCampo = (label, campo) => {
                                let valorNovo = nova[campo];
                                let valorAntigo = antiga[campo];

                                if (isData(campo)) {
                                  valorNovo = valorNovo
                                    ? format.date(valorNovo)
                                    : '';
                                  valorAntigo = valorAntigo
                                    ? format.date(valorAntigo)
                                    : '';
                                }

                                const mudou = valorNovo !== valorAntigo;

                                return (
                                  <div
                                    className="json-item"
                                    style={{ marginBottom: '12px' }}
                                  >
                                    {/* Label em sua própria linha */}
                                    <div
                                      style={{
                                        fontWeight: 'bold',
                                        marginBottom: '4px',
                                      }}
                                    >
                                      {label}
                                    </div>
                                    {/* Valores */}
                                    <div>
                                      {mudou ? (
                                        <>
                                          {gerarPill(valorAntigo, 'red')} →{' '}
                                          {gerarPill(valorNovo, 'green')}
                                        </>
                                      ) : (
                                        valorNovo
                                      )}
                                    </div>
                                  </div>
                                );
                              };

                              switch (historico.tipo_atividade) {
                                case TIPO_ATIVIDADE.TAREFA:
                                  return (
                                    <div>
                                      {renderCampo('Descrição', 'descricao')}
                                      {renderCampo(
                                        'Data para conclusão',
                                        'data'
                                      )}
                                      {renderCampo('Prioridade', 'prioridade')}
                                      {renderCampo('Situação', 'situacao')}
                                      {renderCampo(
                                        'Tipo de Responsável',
                                        'tipoResponsavel'
                                      )}
                                      {renderCampo(
                                        'Responsável',
                                        'responsavel'
                                      )}
                                      {renderCampo(
                                        'Lembrete por E-mail',
                                        'lembreteEmail'
                                      )}
                                    </div>
                                  );

                                case TIPO_ATIVIDADE.VISITA:
                                  return (
                                    <div>
                                      {renderCampo('Descrição', 'descricao')}
                                      {renderCampo(
                                        'Data para conclusão',
                                        'data'
                                      )}
                                      {renderCampo('Situação', 'situacao')}
                                      {renderCampo('PDV', 'pdv')}
                                      {renderCampo(
                                        'Tipo de Responsável',
                                        'tipoResponsavel'
                                      )}
                                      {renderCampo(
                                        'Responsável',
                                        'responsavel'
                                      )}
                                      {renderCampo(
                                        'Visita Virtual',
                                        'visitaVirtual'
                                      )}
                                      {renderCampo(
                                        'Tipo de Visita',
                                        'tipoVisita'
                                      )}
                                      {renderCampo(
                                        'Recalcular Vencimento',
                                        'recalcularVencimento'
                                      )}
                                      {renderCampo(
                                        'Formas de Notificação:',
                                        'formasNotificacoes'
                                      )}
                                    </div>
                                  );

                                case TIPO_ATIVIDADE.ANOTACAO:
                                  return (
                                    <div>
                                      {renderCampo('Descrição', 'descricao')}
                                    </div>
                                  );

                                default:
                                  return null;
                              }
                            })()}
                        </div>
                      </div>
                    </div>
                  </TimelineItem>
                ))}
              </Timeline>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              size="sm"
              type="button"
              className="d-inline-flex align-items-center"
              onClick={() => {
                toggleModalHistorico();
                setHistoricoSelecionado(null);
              }}
            >
              <FaWindowClose />
              <span className="ml-2 d-xs-none">Fechar</span>
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default AtividadesTimeline;
